import { API_ENDPOINTS } from "@/constants/api";
import { axiosApiInstance, axiosLoginInstance } from "@/libs/axios";

export const singIn = async (email: string) => {
  return axiosLoginInstance.post<{ code: "token_generated" | "email_not_found" }>(
    API_ENDPOINTS.AUTH.LOGIN,
    { email },
  );
};
export const Register = async (email: string, first_name: string, last_name: string) => {
  return axiosLoginInstance.post<{ code: "account_created" }>(API_ENDPOINTS.AUTH.REGISTER, {
    email,
    first_name,
    last_name,
  });
};

export type VerifySsoTokenData = {};
export const verifySsoToken = async ({ token, email }: { token: string; email: string }) => {
  return axiosApiInstance.post<{ code: "verified_successfully"; data: { login_token: string } }>(
    API_ENDPOINTS.AUTH.SSO_VERIFICATION,
    { token, email },
  );
};
